export const VISIBILITY = Object.freeze({
  PRIVATE: "private",
  PROJECT: "project",
  PUBLIC: "public",
});

export const SHAPE_TYPE = Object.freeze({
  MARKER: "marker",
  POLYGON: "polygon",
  LINE: "line",
});

/** Default form id when a project has multiple forms (legacy panel + wizard). */
export const DEFAULT_PROJECT_FORM_ID = 270;

export const ORG_TYPE = Object.freeze({
  INDIVIDUAL: "individual",
  ORGANIZATION: "organization",
});

export const ORG_TYPE_OPTIONS = Object.freeze([
  { value: ORG_TYPE.INDIVIDUAL, label: "Individual" },
  { value: ORG_TYPE.ORGANIZATION, label: "Organization" },
]);
